module.exports = __webpack_public_path__ + "static/img/5.c8e093e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/4/1/sp/5.png
// module id = eEQN
// module chunks = 0